import React, { useState } from "react";
import cn from "classnames";
//import PropTypes from 'prop-types';

import "./style.css";
import Field from "containers/Field";
import Button from "components/Button";
import IconButton from "components/IconButton";
import Preloader from "components/Preloader";
import { useApiActions, useData } from "state/hooks";
import { uploadVersion } from "state/actions/upload";
import UploadButton from "components/upload/UploadButton";
import DateDiff from "components/DateDiff";
import { useSelector } from "react-redux";

function displayedFileName(file) {
    const path = file?.file || null;
    if (!path) return null;
    if (path.includes(".versions")) {
        return path.split("/").pop();
    }
    return path.split("/").slice(1).join("/");
}

function selectVersions(store, type, file) {
    const all = Object.values(store?.data?.[type] || {});
    return all
        .filter((item) => {
            return item.file.includes(`.versions/${file}`);
        })
        .sort((a, b) => {
            if (a.updated_at < b.updated_at) return 1;
            if (a.updated_at > b.updated_at) return -1;
            return 0;
        })
        .map((item) => item.id);
}

function FileVersion({ id }) {
    const data = useData({ type: "cms.media", id });
    const fileName = displayedFileName(data);
    return (
        <div>
            <div>{fileName}</div>
            <div className={"version-timestamp"}>
                <DateDiff value={data.updated_at} />
            </div>
        </div>
    );
}

function SymlinkTarget(props) {
    const { id, onClick } = props;
    const { onUpload } = useApiActions({ onUpload: uploadVersion });
    const { file, target_id } = useData({ type: "cms.media", id });
    const data = useData({ type: "cms.media", id: target_id });

    const [showHistory, setShowHistory] = useState(false);

    const fileName = displayedFileName(data) || "Wybierz plik docelowy";
    const versions = useSelector((store) =>
        selectVersions(store, "cms.media", file)
    );

    const handleUpload = (files) => {
        onUpload("cms.media", "browser", id, files[0]);
    };

    return (
        <div className={"rows gap-sm"}>
            <div className={"cols cols-spread cols-middle"}>
                <div>Plik docelowy dla odsyłacza</div>
                <div>
                    <IconButton
                        icon={"mui-history"}
                        size={"small"}
                        onClick={() => setShowHistory(!showHistory)}
                    />
                </div>
            </div>
            <div className={"symlink-target"}>
                <div className={"cols gap-xs cols-spread"}>
                    <div>
                        <div>{fileName}</div>
                        {data?.updated_at && (
                            <div className={"version-timestamp"}>
                                <DateDiff value={data.updated_at} />
                            </div>
                        )}
                    </div>
                    <div className={"cols cols-middle"}>
                        <IconButton onClick={onClick} icon={"mui-search"} />
                        <UploadButton
                            onUpload={handleUpload}
                            trigger={<IconButton icon={"mui-cloud_upload"} />}
                        />
                    </div>
                </div>
                {showHistory && (
                    <div className={"rows gap-xs"}>
                        {versions.map((version) => (
                            <FileVersion id={version} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export function MediaPreview(props) {
    const {
        id,
        alt,
        title,
        fileType,
        file,
        source,
        onClose,
        onSave,
        onShowPreview,
        onDownload,
        onDelete,
        onSelectSymlinkTarget,
        open,
        preview,
        hasPreview,
        isPending,
        updated_at,
        children,
    } = props;

    const baseFilename =
        fileType === "symlink" ? file : file?.split("/")?.pop();
    const fileExtension = baseFilename?.split(".")?.pop();

    return (
        <div
            className={cn("media-preview-container", {
                "is-open": open,
            })}
        >
            <div className={"media-preview"}>
                <Preloader visible={isPending} />
                <div className={"rows gap-md"}>
                    <div className={"cols cols-middle cols-spread gap-md"}>
                        <div>{fileExtension}</div>
                        <div className={"cols cols-right cols-middle gap-md"}>
                            <div className={"cols"}>
                                <IconButton
                                    icon={"mui-download"}
                                    onClick={onDownload}
                                />
                                <IconButton
                                    icon={"mui-delete"}
                                    onClick={onDelete}
                                />
                                <IconButton
                                    icon={"mui-fullscreen"}
                                    onClick={onShowPreview}
                                />
                            </div>
                            <IconButton icon={"mui-close"} onClick={onClose} />
                        </div>
                    </div>
                    {hasPreview && (
                        <div className={"media-preview-img"}>{children}</div>
                    )}
                    <div>{baseFilename}</div>
                    {fileType === "symlink" && (
                        <SymlinkTarget
                            id={id}
                            onClick={() => onSelectSymlinkTarget(id)}
                        />
                    )}
                    <div className={"rows gap-sm"}>
                        <Field id={"title"} label={"Title"} />
                        <Field id={"alt"} label={"ALT"} />
                        {fileType === "document" && (
                            <Field
                                id={"noindex"}
                                negate={true}
                                label={
                                    "Pozwalaj na indeksowanie przez wyszukiwarki"
                                }
                                fieldType={"checkbox"}
                            />
                        )}
                        <div className={"cols cols-spread"}>
                            <DateDiff value={updated_at} />
                            <Button onClick={onSave} disabled={isPending}>
                                Zapisz
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

MediaPreview.propTypes = {};

MediaPreview.defaultProps = {
    isPending: false,
};

export default MediaPreview;
